import { MessageCircle, MapPin } from "lucide-react";
import { ctaFinal, whatsappLink } from "@/content";
import { Reveal, Overline } from "./Reveal";
import { LocationMap } from "./LocationMap";

const BG = "https://images.unsplash.com/photo-1757466762489-52fea38071ad?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export const FinalCTA = () => (
  <section id="contato" data-testid="final-cta-section" className="relative scroll-mt-20 py-20 md:py-28 lg:py-36">
    <div className="mx-auto max-w-7xl px-6 lg:px-8">
      <Reveal>
        <div className="relative overflow-hidden rounded-[2rem] border border-cyan-300/15 bg-[#061229] px-6 py-14 sm:px-8 sm:py-20 md:px-16 lg:py-28">
          <img src={BG} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-25 mix-blend-screen" />
          <div className="absolute -bottom-32 -right-20 h-96 w-96 rounded-full bg-cyan-400/20 blur-[100px]" />
          <div className="relative max-w-2xl">
            <Overline>{ctaFinal.overline}</Overline>
            <h2 data-testid="final-cta-title" className="font-display mt-6 text-3xl font-semibold tracking-tight text-white md:text-5xl">
              {ctaFinal.titulo}
            </h2>
            <p className="mt-6 text-base leading-relaxed text-slate-300 md:text-lg">{ctaFinal.texto}</p>
            <a href={whatsappLink()} target="_blank" rel="noopener noreferrer" data-testid="final-cta-whatsapp-btn" className="btn-primary mt-12">
              <MessageCircle size={18} />
              {ctaFinal.botao}
            </a>
            <p className="mt-8 flex items-start gap-2 text-sm text-slate-300">
              <MapPin size={16} className="mt-0.5 shrink-0 text-cyan-300" />
              {ctaFinal.atendimento}
            </p>
          </div>
        </div>
      </Reveal>
      <LocationMap />
    </div>
  </section>
);
